import React, { useEffect, useState}  from "react";
import { useStyles } from "./styles";
import { Grid, ListSubheader, TextField, Typography } from "@material-ui/core";
import {  Controller } from "react-hook-form";
import clsx from "clsx";
import MenuItem from "@material-ui/core/MenuItem";

const CreditCardTerminalSelection = ({
    availableCreditCardTerminals,
    currentSelectedTerminal,
    control,
    errors
  }) => {
  const classes = useStyles();

  const groupNames={
    1:'Windcave',
    2:'Planet',
    3:'Elavon',
  }
  const [groupedData,setGroupedData]=useState({});
  const [unGroupedData,setunGroupedData]=useState([{name: 'Cash Only', value: -1, ccGatewayId: -1}]);

  useEffect(() => {
    const grouped = {};
    const unGrouped = [];
    if (availableCreditCardTerminals?.length > 0) {
      availableCreditCardTerminals.forEach((item) => {
        if (item.ccGatewayId === -1) {
          unGrouped.push(item);
        } else {
          if (!grouped[item.ccGatewayId]) {
            grouped[item.ccGatewayId] = [];
          }
          grouped[item.ccGatewayId].push(item);
        }
      });
      setGroupedData(grouped);
      setunGroupedData(unGrouped);
    }
  }, [availableCreditCardTerminals]);
  
  return (
    <div className={clsx("card-content", classes.contentRoot)}>
      <Grid item xs={12} lg={6} className={clsx(classes.creditCardTerminalSelectionContainer)}>
         <Typography className={clsx("credit-card-terminal-selection")} variant="h5">
          Choose Your CC Terminal
        </Typography>
        <Controller
          name="creditcardterminal"
          control={control}
          render={({ field }) => (
            <TextField
              label="Credit Card Terminal"
              fullWidth
              {...field}
              defaultValue={currentSelectedTerminal}
              error={!!errors.creditcardterminal}
              helperText={errors.creditcardterminal && "Required"}
              id="creditcardterminal"
              className={clsx(
                "creditcardterminal",
                classes.creditCardTerminalDropdown
              )}
              select
              variant="outlined"
              SelectProps={{
                SelectDisplayProps: {
                  "data-testid": "credit-card-terminal-selection",
                  "data-options": availableCreditCardTerminals?.map(terminal => terminal.name),
                  "aria-label": "cc-terminal-dropdown"
                },
              }}
            >
              {unGroupedData.map((item) => (
                <MenuItem
                  key={item.name}
                  value={item.value}
                  className={clsx("terminal-option")}
                  data-name={item.name}
                >
                  {item.name}
                </MenuItem>
              ))}
              {Object.entries(groupedData).map(([groupId, items]) => [
                <ListSubheader
                  key={groupId}
                  className={clsx(classes.listSubHeader)}
                  onClickCapture={(e) => e.stopPropagation()}
                >
                  {groupNames[groupId]}
                </ListSubheader>,
                items.map((item, index) => (
                <MenuItem
                    key={item.name}
                    value={item.value}
                    className={clsx("terminal-option")}
                    data-testid={`terminal-option-${index}`}
                    data-name={item.name}
                    terminal-type={groupNames[groupId]}
                  >
                    {item.name}
                </MenuItem>
                )),
              ])}
            </TextField>
          )}
        />
      </Grid>
    </div>
  );
};

export default CreditCardTerminalSelection;